import Vue from 'vue'
import store from '..'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  namespaced: true,
  state () {
    return {
      holidays: [],
      reference: null,
      initial: {
        key: null,
        name: null,
        events: [],
        enable: false,
        createdAt: null,
        updatedAt: null
      }
    }
  },
  getters: {
    holidays (state) {
      return state.holidays
    },
    reference (state) {
      return state.reference
    },
    initial (state) {
      return state.initial
    }
  },
  mutations: {
    init (state, payload) {
      state.holidays = payload
    },
    add (state, payload) {
      state.holidays.push(payload)
    },
    update (state, payload) {
      const index = state.holidays.findIndex(holiday => holiday.key === payload.key)
      if (index !== -1) {
        Vue.set(state.holidays, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.holidays.findIndex(holiday => holiday.key === payload.key)
      if (index !== -1) {
        state.holidays.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      return new Promise((resolve) => {
        commit('init', [])
        resolve()
      })
    },
    subscribe ({ commit }) {
      var boot = true
      var temp = []
      return new Promise((resolve, reject) => {
        commit('init', [])
        const db = firebase.firestore()
        var dbRef = db.collection('holidays')
        var reference = dbRef.orderBy('createdAt', 'asc').onSnapshot(snapshots => {
          if (snapshots.empty) {
            resolve()
          }
          snapshots.docChanges().forEach(change => {
            var data = JSON.parse(JSON.stringify(change.doc.data()))
            if (boot && change.type === 'added') {
              temp.push(data)
            } else if (change.type === 'added') {
              commit('add', data)
            } else if (change.type === 'modified') {
              commit('update', data)
            } else if (change.type === 'removed') {
              commit('remove', data)
            }
          })
          if (boot) {
            boot = false
            commit('init', temp)
          }
          resolve()
        })
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['holidays/reference']
      return new Promise((resolve) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('init', [])
          resolve()
        } else {
          resolve()
        }
      })
    },
    write ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        var ref = null
        if (payload.key) {
          ref = db.collection('holidays').doc(payload.key)
        } else {
          ref = db.collection('holidays').doc()
          payload.key = ref.id
        }
        ref.set(payload)
          .then(function () {
            const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
            pause(100).then(() => {
              console.log('Document successfully written!')
              resolve(payload)
            })
          })
          .catch(function (error) {
            console.error('Error writing document: ', error)
            resolve()
          })
      })
    },
    delete ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        db.collection('holidays').doc(payload).delete().then(function () {
          console.log('Document successfully deleted!')
          resolve()
        }).catch(function (error) {
          console.error('Error removing document: ', error)
          resolve()
        })
      })
    }
  }
}
